
import SplunkDataSans from './assets/fonts/SplunkDataSans-regular.woff2';
import SplunkDataSansBold from './assets/fonts/SplunkDataSans-bold.woff2';
import SplunkDataSansMedium from './assets/fonts/SplunkDataSans-medium.woff2';
import SplunkDataSansMono from './assets/fonts/SplunkDataSansMono-regular.woff2';

export const thinScrollBar = `
::-webkit-scrollbar {
  -webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
  width: .5rem;
}

::-webkit-scrollbar:horizontal {
  height: .5rem;
}

::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid #888888;
  background-color: rgba(0, 0, 0, .5);
}
 `;

export const PrismaGlobals = `
    /**
     * Prisma Typefaces
     */
    @font-face {
        font-family: 'SplunkDataSans';
        src: url(${SplunkDataSans}) format('woff2');
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: 'SplunkDataSans';
        src: url(${SplunkDataSansMedium}) format('woff2');
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: 'SplunkDataSans';
        src: url(${SplunkDataSansMedium}) format('woff2');
        font-weight: 600;
        font-style: normal;
    }
    @font-face {
        font-family: 'SplunkDataSans';
        src: url(${SplunkDataSansBold}) format('woff2');
        font-weight: 700;
        font-style: normal;
    }
    @font-face {
        font-family: 'SplunkDataSansMono';
        src: url(${SplunkDataSansMono}) format('woff2');
        font-weight: 400;
        font-style: normal;
    }

    /**
     * Prisma globals
     */
    * {
        box-sizing: border-box;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-kerning: auto;
    }
    html, body {
        font-family: 'SplunkDataSans';
        font-weight: 400;
        font-size: 16px;
    }
    h1, h2, h3, h4, h5, h6 {
        margin: 0;
        padding: 0;
    }
`;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/themes/common/globalSnippets.styles.js